import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { RouteGuard } from "@/components/permissions/route-guard";

export const Route = createFileRoute("/_authenticated/quotations")({
  component: QuotationsLayout,
});

function QuotationsLayout() {
  return (
    <RouteGuardPermissions
      permissions={[{ module: "quotations", actions: ["read"] }]}
    >
      <Outlet />
    </RouteGuardPermissions>
  );
}
